export const stationFormPost = (formValues, products = []) => {
  const location = formValues?.stationLocation?.split(",");
  return {
    name: formValues?.stationName || "",
    stationCode: Number(formValues?.stationCode),
    businessName: formValues?.businessName || "",
    customerCode: formValues?.customerCode || "",
    stationType: formValues?.stationType || "",
    island: formValues?.island || "",
    area: formValues?.province || "",
    latitude: location?.[0] ? Number(location[0]) : null,
    longitude: location?.[1] ? Number(location[1]) : null,
    products,
  };
};

export const stationFormGet = (data) => {
  const lat = data?.latitude ?? "";
  const long = data?.longitude ?? "";
  const location = lat === "" && long === "" ? "" : `${lat}, ${long}`;
  return {
    stationCode: { value: data?.stationCode != null ? String(data.stationCode).padStart(4, "0") : "" },
    stationName: { value: data?.name || "" },
    businessName: { value: data?.businessName || "" },
    customerCode: { value: String(data?.customerCode || "") },
    stationType: { value: data?.stationType || "" },
    island: { value: data?.island || "" },
    province: { value: data?.area || data?.province || "" },
    stationLocation: { value: location },
  };
};
